export default {
  active: {
    fontFamily: 'ItauText-XBold',
  },
};
